// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: #fff;
  overflow: hidden;
}

.eb-root {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

/* Legacy compact title bar (~7% / small fixed height) */
.expression-builder {
  flex-shrink: 0;
  height: 7%;
  min-height: 32px;
  max-height: 40px;
  background-color: #17a2b8;
  display: flex;
  align-items: center;
  padding-left: 1%;
  padding-right: 4px;
  box-sizing: border-box;
}

.build-expression-header {
  flex: 1;
  width: 97%;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.2;
}

.expression-builder-close {
  flex: 0 0 3%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  color: #fff;
  background: transparent;
  border: none;
  padding: 0;
  line-height: 0;
}
.expression-builder-close mat-icon {
  color: #fff;
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.expressionWrap {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

/* Same as original: bold single-line preview bar */
.expression {
  padding: 1%;
  font-weight: bold;
  font-size: 13px;
  box-sizing: border-box;
  min-height: 6%;
  max-height: 15%;
  width: 100%;
  background-color: #e8fcff;
  display: flex;
  overflow: auto;
  flex-shrink: 0;
}

.eb-top {
  flex-shrink: 0;
  padding: 12px 16px 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-bottom: 1px solid #eef2f7;
  background: #fafcfd;
}

.eb-panel-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 6px;
}

.eb-manual-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.eb-manual-input {
  flex: 1;
  min-width: 0;
  border: 1px solid #cfd8e3;
  border-radius: 6px;
  padding: 0 10px;
  font-size: 12px;
  height: 30px;
  box-sizing: border-box;
}

.eb-apply-btn {
  flex-shrink: 0;
  min-height: 28px !important;
  max-height: 30px !important;
  padding: 2px 12px !important;
  font-size: 11px !important;
  line-height: 1.2 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.expressionBuilderBody {
  background: #fff;
  overflow: auto;
  padding: 10px 16px 12px;
  flex: 1 1 0;
  min-height: 0;
}

.eb-form {
  height: auto;
}

/* Neutral group frame (legacy used teal border; match “no group color”) */
.eb-group-card {
  border: 1px solid #cfd8e3;
  border-radius: 6px;
  padding: 10px 10px 8px;
  margin-bottom: 10px;
  background: #fff;
  box-shadow: none;
  overflow: visible;
}

.eb-group-rows {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 8px;
}

.eb-group-rows .eb-rule-row:not(:first-child) {
  margin-top: 2px;
  padding-top: 4px;
}

.eb-rule-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.eb-rule-row > .eb-add-rule-btn,
.eb-rule-row > .eb-icon-btn {
  align-self: center;
}

/* First rule row: slight extra offset so label clears group top border */
.eb-group-card .eb-rule-row:first-child .eb-field-rule {
  margin-top: 0;
}

.eb-field {
  margin-bottom: 0 !important;
}

/* Match legacy layout: compact ~23% width fields (not full-row stretch). */
.eb-field-condition {
  flex: 0 0 23%;
  width: 23%;
  max-width: 23%;
  min-width: 96px;
  box-sizing: border-box;
}

.eb-field-rule {
  flex: 0 0 23%;
  width: 23%;
  max-width: 23%;
  min-width: 96px;
  box-sizing: border-box;
}

.eb-field-group-op {
  flex: 0 0 23%;
  width: 23%;
  max-width: 220px;
  margin-bottom: 0 !important;
}

.eb-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  min-width: 26px;
  min-height: 26px;
  border-radius: 4px;
  border: 1px solid #cbd5e1;
  background: #fff;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  line-height: 0;
}
.eb-icon-btn mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  line-height: 15px;
}

.eb-icon-danger {
  color: #64748b;
  border-color: #cbd5e1;
}
.eb-icon-danger:hover {
  background: #fef2f2;
  border-color: #fca5a5;
  color: #b91c1c;
}

/* Same pattern as original: small teal raised + white FA icon, icon optically centered */
.eb-add-rule-btn {
  width: 26px !important;
  min-width: 26px !important;
  height: 26px !important;
  min-height: 26px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 0 !important;
  flex-shrink: 0;
}
.eb-add-rule-btn .fa {
  font-size: 11px !important;
  line-height: 1 !important;
  color: #fff !important;
  display: block;
  margin: 0;
  padding: 0;
  text-align: center;
}

.eb-group-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px dashed #dee2e6;
}

/* Legacy-short Add / Remove group controls (match old mat-raised-button + btn-xs height) */
.eb-group-action-btn {
  min-height: 26px !important;
  max-height: 28px !important;
  line-height: 1.1 !important;
  padding: 1px 10px !important;
  font-size: 10px !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px;
}
.eb-group-action-btn .fa {
  font-size: 11px !important;
  line-height: 1 !important;
}

.eb-between-groups {
  margin-top: 12px;
}

.expressionBuilderFooter {
  flex-shrink: 0;
  height: 7%;
  min-height: 40px;
  max-height: 48px;
  display: flex;
  align-items: center;
  padding: 4px 1% 6px;
  background-color: #fff;
  border-radius: 0 0 10px 10px;
  box-sizing: border-box;
}

.expressionBuilderFooter-message {
  height: 100%;
  width: 85%;
  display: flex;
  align-items: center;
  color: red;
  font-size: 12px;
  overflow: auto;
}

.create-expression {
  height: 100%;
  width: 15%;
  min-width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.noRulesBody {
  flex: 1;
  background: #fff;
  overflow: auto;
  padding: 24px 16px;
  text-align: center;
  font-size: 13px;
  color: #64748b;
}

:host ::ng-deep {
  /* Match routing-ruleconfig label/outline behavior exactly for EB fields. */
  /* mat-raised-button default min-height is tall; force compact group actions */
  /* Pull stacked rows slightly further apart (label notch vs previous outline) */
}
:host ::ng-deep .mat-mdc-dialog-content {
  overflow: hidden !important;
}
:host ::ng-deep .mdc-dialog__surface {
  overflow: hidden !important;
}
:host ::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled),
:host ::ng-deep .mdc-text-field--focused,
:host ::ng-deep .mdc-text-field--filled,
:host ::ng-deep .mat-mdc-form-field {
  background-color: #fff !important;
  --mdc-filled-text-field-focus-active-indicator-color: none !important;
}
:host ::ng-deep .mat-mdc-form-field-type-mat-input,
:host ::ng-deep .mat-mdc-form-field-type-mat-select {
  --mdc-filled-text-field-focus-label-text-color: black;
}
:host ::ng-deep .mat-mdc-form-field-type-mat-input .mat-mdc-form-field-subscript-wrapper,
:host ::ng-deep .mat-mdc-form-field-type-mat-select .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
:host ::ng-deep .eb-field.mat-mdc-form-field {
  margin: 0 !important;
  --mat-form-field-container-height: 36px;
  --mat-form-field-container-vertical-padding: 8px;
  --mdc-outlined-text-field-container-height: 36px;
}
:host ::ng-deep .eb-field.mat-mdc-form-field .mat-mdc-text-field-wrapper,
:host ::ng-deep .eb-field.mat-mdc-form-field .mdc-text-field--outlined {
  min-height: 36px;
  height: 36px;
  border-radius: 4px;
  background: #ffffff !important;
}
:host ::ng-deep .eb-field.mat-mdc-form-field .mat-mdc-form-field-infix {
  min-height: 36px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
:host ::ng-deep .eb-field.mat-mdc-form-field .mdc-notched-outline__leading,
:host ::ng-deep .eb-field.mat-mdc-form-field .mdc-notched-outline__notch,
:host ::ng-deep .eb-field.mat-mdc-form-field .mdc-notched-outline__trailing {
  border-color: #cfd8e3 !important;
}
:host ::ng-deep .eb-field.mat-mdc-form-field .mdc-floating-label:not(.mdc-floating-label--float-above) {
  top: 50% !important;
  transform: translateY(-50%) !important;
}
:host ::ng-deep .eb-field.mat-mdc-form-field .mdc-floating-label--float-above {
  top: -9px !important;
  transform: scale(0.75) !important;
  transform-origin: left top;
  background: #fff;
  padding: 0 4px;
}
:host ::ng-deep .eb-field.mat-mdc-form-field .mat-mdc-input-element {
  font-size: 12px;
  color: #1e293b;
}
:host ::ng-deep .eb-field-rule .mat-mdc-form-field,
:host ::ng-deep .eb-field-condition .mat-mdc-form-field {
  width: 100%;
}
:host ::ng-deep .eb-field-group-op .mat-mdc-form-field {
  width: 100%;
}
:host ::ng-deep .eb-group-action-btn.mat-mdc-raised-button {
  min-height: 26px !important;
  --mdc-protected-button-container-height: 26px;
  line-height: 1.1 !important;
}
:host ::ng-deep .eb-group-action-btn .mdc-button__label {
  letter-spacing: normal;
}
:host ::ng-deep .eb-rule-row > .mat-mdc-form-field {
  align-self: center;
  margin-top: 0;
  margin-bottom: 0;
}
:host ::ng-deep .eb-group-rows .eb-rule-row:not(:first-child) > .mat-mdc-form-field {
  margin-top: 4px;
}

/* mat-select — non-blocking backdrop while panel is open (same as create-rules / custom-rules) */
::ng-deep body.routing-mat-select-open .cdk-overlay-backdrop.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  pointer-events: none !important;
}

::ng-deep .mat-mdc-select-panel.routing-mat-select-panel {
  z-index: 10001 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/rule-config-component/expression-builder/expression-builder.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AADF;;AAIA,wDAAA;AACA;EACE,cAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AADF;;AAIA;EACE,OAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AADF;;AAIA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;AADF;AAGE;EACE,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AADJ;;AAKA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AAFF;;AAKA,mDAAA;AACA;EACE,WAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gCAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAnGQ;EAoGR,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAFF;;AAKA;EACE,OAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AAFF;;AAKA;EACE,cAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;AAFF;;AAKA;EACE,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA,0EAAA;AACA;EACE,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;AAFF;;AAKA;;EAEE,kBAAA;AAFF;;AAKA,yEAAA;AACA;EACE,aAAA;AAFF;;AAKA;EACE,2BAAA;AAFF;;AAKA,2EAAA;AACA;EACE,aAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;AAFF;;AAKA;EACE,aAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;AAFF;;AAKA;EACE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,2BAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;EACA,cAAA;AAFF;AAIE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAFJ;;AAMA;EACE,cAAA;EACA,qBAAA;AAHF;AAKE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAHJ;;AAOA,yFAAA;AACA;EACE,sBAAA;EACA,0BAAA;EACA,uBAAA;EACA,2BAAA;EACA,qBAAA;EACA,oBAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,yBAAA;EACA,cAAA;AAJF;AAME;EACE,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AAJJ;;AAQA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,8BAAA;AALF;;AAQA,2FAAA;AACA;EACE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;EACA,QAAA;AALF;AAOE;EACE,0BAAA;EACA,yBAAA;AALJ;;AASA;EACE,gBAAA;AANF;;AASA;EACE,cAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;AANF;;AASA;EACE,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;AANF;;AASA;EACE,YAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AANF;;AASA;EACE,OAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cArVS;AA+UX;;AASA;EA0BE,2EAAA;EAuDA,8EAAA;EAiBA,+EAAA;AArGF;AAIE;EACE,2BAAA;AAFJ;AAKE;EACE,2BAAA;AAHJ;AAME;;;;EAIE,iCAAA;EACA,qEAAA;AAJJ;AAOE;;EAEE,qDAAA;AALJ;AAOI;;EACE,wBAAA;AAJN;AASE;EACE,oBAAA;EACA,uCAAA;EACA,gDAAA;EACA,gDAAA;AAPJ;AASI;;EAEE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;AAPN;AAUI;EACE,2BAAA;EACA,2BAAA;EACA,8BAAA;AARN;AAWI;;;EAGE,gCAAA;AATN;AAYI;EACE,mBAAA;EACA,sCAAA;AAVN;AAaI;EACE,oBAAA;EACA,iCAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;AAXN;AAcI;EACE,eAAA;EACA,cA7ZI;AAiZV;AAgBE;;EAEE,WAAA;AAdJ;AAiBE;EACE,WAAA;AAfJ;AAmBE;EACE,2BAAA;EACA,6CAAA;EACA,2BAAA;AAjBJ;AAoBE;EACE,sBAAA;AAlBJ;AAqBE;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;AAnBJ;AAuBE;EACE,eAAA;AArBJ;;AAyBA,iGAAA;AACA;EAEE,+BAAA;AAvBF;;AA0BA;EACE,yBAAA;AAvBF","sourcesContent":["$eb-text: #1e293b;\r\n$eb-muted: #64748b;\r\n\r\n:host {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  min-height: 0;\r\n  background: #fff;\r\n  overflow: hidden;\r\n}\r\n\r\n.eb-root {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  min-height: 0;\r\n}\r\n\r\n/* Legacy compact title bar (~7% / small fixed height) */\r\n.expression-builder {\r\n  flex-shrink: 0;\r\n  height: 7%;\r\n  min-height: 32px;\r\n  max-height: 40px;\r\n  background-color: #17a2b8;\r\n  display: flex;\r\n  align-items: center;\r\n  padding-left: 1%;\r\n  padding-right: 4px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.build-expression-header {\r\n  flex: 1;\r\n  width: 97%;\r\n  color: #fff;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  line-height: 1.2;\r\n}\r\n\r\n.expression-builder-close {\r\n  flex: 0 0 3%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  cursor: pointer;\r\n  color: #fff;\r\n  background: transparent;\r\n  border: none;\r\n  padding: 0;\r\n  line-height: 0;\r\n\r\n  mat-icon {\r\n    color: #fff;\r\n    font-size: 20px;\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n}\r\n\r\n.expressionWrap {\r\n  flex: 1 1 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Same as original: bold single-line preview bar */\r\n.expression {\r\n  padding: 1%;\r\n  font-weight: bold;\r\n  font-size: 13px;\r\n  box-sizing: border-box;\r\n  min-height: 6%;\r\n  max-height: 15%;\r\n  width: 100%;\r\n  background-color: #e8fcff;\r\n  display: flex;\r\n  overflow: auto;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.eb-top {\r\n  flex-shrink: 0;\r\n  padding: 12px 16px 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  border-bottom: 1px solid #eef2f7;\r\n  background: #fafcfd;\r\n}\r\n\r\n.eb-panel-label {\r\n  display: block;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: $eb-text;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.eb-manual-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.eb-manual-input {\r\n  flex: 1;\r\n  min-width: 0;\r\n  border: 1px solid #cfd8e3;\r\n  border-radius: 6px;\r\n  padding: 0 10px;\r\n  font-size: 12px;\r\n  height: 30px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.eb-apply-btn {\r\n  flex-shrink: 0;\r\n  min-height: 28px !important;\r\n  max-height: 30px !important;\r\n  padding: 2px 12px !important;\r\n  font-size: 11px !important;\r\n  line-height: 1.2 !important;\r\n  display: inline-flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n}\r\n\r\n.expressionBuilderBody {\r\n  background: #fff;\r\n  overflow: auto;\r\n  padding: 10px 16px 12px;\r\n  flex: 1 1 0;\r\n  min-height: 0;\r\n}\r\n\r\n.eb-form {\r\n  height: auto;\r\n}\r\n\r\n/* Neutral group frame (legacy used teal border; match “no group color”) */\r\n.eb-group-card {\r\n  border: 1px solid #cfd8e3;\r\n  border-radius: 6px;\r\n  padding: 10px 10px 8px;\r\n  margin-bottom: 10px;\r\n  background: #fff;\r\n  box-shadow: none;\r\n  overflow: visible;\r\n}\r\n\r\n.eb-group-rows {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  padding-top: 8px;\r\n}\r\n\r\n.eb-group-rows .eb-rule-row:not(:first-child) {\r\n  margin-top: 2px;\r\n  padding-top: 4px;\r\n}\r\n\r\n.eb-rule-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.eb-rule-row > .eb-add-rule-btn,\r\n.eb-rule-row > .eb-icon-btn {\r\n  align-self: center;\r\n}\r\n\r\n/* First rule row: slight extra offset so label clears group top border */\r\n.eb-group-card .eb-rule-row:first-child .eb-field-rule {\r\n  margin-top: 0;\r\n}\r\n\r\n.eb-field {\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n/* Match legacy layout: compact ~23% width fields (not full-row stretch). */\r\n.eb-field-condition {\r\n  flex: 0 0 23%;\r\n  width: 23%;\r\n  max-width: 23%;\r\n  min-width: 96px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.eb-field-rule {\r\n  flex: 0 0 23%;\r\n  width: 23%;\r\n  max-width: 23%;\r\n  min-width: 96px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.eb-field-group-op {\r\n  flex: 0 0 23%;\r\n  width: 23%;\r\n  max-width: 220px;\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.eb-icon-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 26px;\r\n  height: 26px;\r\n  min-width: 26px;\r\n  min-height: 26px;\r\n  border-radius: 4px;\r\n  border: 1px solid #cbd5e1;\r\n  background: #fff;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  flex-shrink: 0;\r\n  line-height: 0;\r\n\r\n  mat-icon {\r\n    font-size: 15px;\r\n    width: 15px;\r\n    height: 15px;\r\n    line-height: 15px;\r\n  }\r\n}\r\n\r\n.eb-icon-danger {\r\n  color: #64748b;\r\n  border-color: #cbd5e1;\r\n\r\n  &:hover {\r\n    background: #fef2f2;\r\n    border-color: #fca5a5;\r\n    color: #b91c1c;\r\n  }\r\n}\r\n\r\n/* Same pattern as original: small teal raised + white FA icon, icon optically centered */\r\n.eb-add-rule-btn {\r\n  width: 26px !important;\r\n  min-width: 26px !important;\r\n  height: 26px !important;\r\n  min-height: 26px !important;\r\n  padding: 0 !important;\r\n  margin: 0 !important;\r\n  display: inline-flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  line-height: 0 !important;\r\n  flex-shrink: 0;\r\n\r\n  .fa {\r\n    font-size: 11px !important;\r\n    line-height: 1 !important;\r\n    color: #fff !important;\r\n    display: block;\r\n    margin: 0;\r\n    padding: 0;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.eb-group-actions {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  align-items: center;\r\n  margin-top: 10px;\r\n  padding-top: 8px;\r\n  border-top: 1px dashed #dee2e6;\r\n}\r\n\r\n/* Legacy-short Add / Remove group controls (match old mat-raised-button + btn-xs height) */\r\n.eb-group-action-btn {\r\n  min-height: 26px !important;\r\n  max-height: 28px !important;\r\n  line-height: 1.1 !important;\r\n  padding: 1px 10px !important;\r\n  font-size: 10px !important;\r\n  display: inline-flex !important;\r\n  align-items: center !important;\r\n  gap: 6px;\r\n\r\n  .fa {\r\n    font-size: 11px !important;\r\n    line-height: 1 !important;\r\n  }\r\n}\r\n\r\n.eb-between-groups {\r\n  margin-top: 12px;\r\n}\r\n\r\n.expressionBuilderFooter {\r\n  flex-shrink: 0;\r\n  height: 7%;\r\n  min-height: 40px;\r\n  max-height: 48px;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 4px 1% 6px;\r\n  background-color: #fff;\r\n  border-radius: 0 0 10px 10px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.expressionBuilderFooter-message {\r\n  height: 100%;\r\n  width: 85%;\r\n  display: flex;\r\n  align-items: center;\r\n  color: red;\r\n  font-size: 12px;\r\n  overflow: auto;\r\n}\r\n\r\n.create-expression {\r\n  height: 100%;\r\n  width: 15%;\r\n  min-width: 120px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.noRulesBody {\r\n  flex: 1;\r\n  background: #fff;\r\n  overflow: auto;\r\n  padding: 24px 16px;\r\n  text-align: center;\r\n  font-size: 13px;\r\n  color: $eb-muted;\r\n}\r\n\r\n:host ::ng-deep {\r\n  .mat-mdc-dialog-content {\r\n    overflow: hidden !important;\r\n  }\r\n\r\n  .mdc-dialog__surface {\r\n    overflow: hidden !important;\r\n  }\r\n\r\n  .mdc-text-field--filled:not(.mdc-text-field--disabled),\r\n  .mdc-text-field--focused,\r\n  .mdc-text-field--filled,\r\n  .mat-mdc-form-field {\r\n    background-color: #fff !important;\r\n    --mdc-filled-text-field-focus-active-indicator-color: none !important;\r\n  }\r\n\r\n  .mat-mdc-form-field-type-mat-input,\r\n  .mat-mdc-form-field-type-mat-select {\r\n    --mdc-filled-text-field-focus-label-text-color: black;\r\n\r\n    .mat-mdc-form-field-subscript-wrapper {\r\n      display: none !important;\r\n    }\r\n  }\r\n\r\n  /* Match routing-ruleconfig label/outline behavior exactly for EB fields. */\r\n  .eb-field.mat-mdc-form-field {\r\n    margin: 0 !important;\r\n    --mat-form-field-container-height: 36px;\r\n    --mat-form-field-container-vertical-padding: 8px;\r\n    --mdc-outlined-text-field-container-height: 36px;\r\n\r\n    .mat-mdc-text-field-wrapper,\r\n    .mdc-text-field--outlined {\r\n      min-height: 36px;\r\n      height: 36px;\r\n      border-radius: 4px;\r\n      background: #ffffff !important;\r\n    }\r\n\r\n    .mat-mdc-form-field-infix {\r\n      min-height: 36px !important;\r\n      padding-top: 8px !important;\r\n      padding-bottom: 8px !important;\r\n    }\r\n\r\n    .mdc-notched-outline__leading,\r\n    .mdc-notched-outline__notch,\r\n    .mdc-notched-outline__trailing {\r\n      border-color: #cfd8e3 !important;\r\n    }\r\n\r\n    .mdc-floating-label:not(.mdc-floating-label--float-above) {\r\n      top: 50% !important;\r\n      transform: translateY(-50%) !important;\r\n    }\r\n\r\n    .mdc-floating-label--float-above {\r\n      top: -9px !important;\r\n      transform: scale(0.75) !important;\r\n      transform-origin: left top;\r\n      background: #fff;\r\n      padding: 0 4px;\r\n    }\r\n\r\n    .mat-mdc-input-element {\r\n      font-size: 12px;\r\n      color: $eb-text;\r\n    }\r\n  }\r\n\r\n  .eb-field-rule .mat-mdc-form-field,\r\n  .eb-field-condition .mat-mdc-form-field {\r\n    width: 100%;\r\n  }\r\n\r\n  .eb-field-group-op .mat-mdc-form-field {\r\n    width: 100%;\r\n  }\r\n\r\n  /* mat-raised-button default min-height is tall; force compact group actions */\r\n  .eb-group-action-btn.mat-mdc-raised-button {\r\n    min-height: 26px !important;\r\n    --mdc-protected-button-container-height: 26px;\r\n    line-height: 1.1 !important;\r\n  }\r\n\r\n  .eb-group-action-btn .mdc-button__label {\r\n    letter-spacing: normal;\r\n  }\r\n\r\n  .eb-rule-row > .mat-mdc-form-field {\r\n    align-self: center;\r\n    margin-top: 0;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  /* Pull stacked rows slightly further apart (label notch vs previous outline) */\r\n  .eb-group-rows .eb-rule-row:not(:first-child) > .mat-mdc-form-field {\r\n    margin-top: 4px;\r\n  }\r\n}\r\n\r\n/* mat-select — non-blocking backdrop while panel is open (same as create-rules / custom-rules) */\r\n::ng-deep body.routing-mat-select-open\r\n  .cdk-overlay-backdrop.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {\r\n  pointer-events: none !important;\r\n}\r\n\r\n::ng-deep .mat-mdc-select-panel.routing-mat-select-panel {\r\n  z-index: 10001 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
